<script setup>
  import MovingDivider from '@/components/MovingDivider.vue'
  import SponsorTile from "@/components/SponsorTile.vue";
</script>

<template>
  <div class="sponsors-wrapper">
    <section id="sponsors">
      <h2 id="our-sponsors" class="header">
        <a href="#our-sponsors" class="header-link">Our Sponsors</a>
      </h2>
      <p class="message">
        If you are interested in sponsoring us and would like to know more, please check out our
        <a :href="$store.state.general.sponsorshipPackage" target="_blank">
          sponsorship package</a>!
      </p>
      <div class="sponsors-display">
        <SponsorTile v-for="(sponsor, index) in sponsors" :key="index" :data="sponsor"/>
      </div>
    </section>

    <MovingDivider :bottom="true" :index="1"/>
  </div>
</template>

<script>

export default {
    name: "SponsorsView",
    components: {
      SponsorTile,
      MovingDivider
    },
    computed: {
      sponsors(){
        return this.$store.state.sponsors;
      }
    }
    // data()
    // {
    //   return {
    //     sponsors: []
    //   }
    // },
    // async created()
    // {
    //   const sponsors = await getDocs(sponsorsDB)
    //   sponsors.forEach(sponsor => {
    //     this.sponsors.push(sponsor.data())
    //   })
    // }
}
</script>

<style lang="scss">
.sponsors-wrapper{
  position: relative;
  background-color: var(--light);
  color: var(--dark);
  // height: 100vh;

  #sponsors{
    padding: var(--section-padding);
    padding-top: 10em;
    padding-bottom: 2rem;
    height: 100%;
    max-width: var(--max-width);
    margin: auto;

    .header{
      text-align: left;
    }

    .message{
      text-align: left;
      margin-top: 0.5em;
      margin-bottom: 1.5rem;
      font-style: italic;
      font-size: 1rem;
      line-height: 1.35;

      a {
        color: var(--dark);
        text-decoration: underline;
        font-weight: bold;
      }
    }

    .sponsors-display
    {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-evenly;
      align-items: center;
      column-gap: 4em;
    }
  }
}

@media screen and (max-width: 768px) {
  .sponsors-wrapper {
    #sponsors {
      padding: 5.5rem var(--section-padding-mobile, 6%) 1.5rem;

      .message {
        font-size: 0.95rem;
        line-height: 1.35;
        text-align: left;
      }

      .sponsors-display {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1.25rem 0.75rem;
        justify-items: center;
        align-items: center;
      }
    }
  }
}
</style>